export class EonAccount {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "domain",
            "baseName": "domain",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "EonAccountStatus",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "EonAccountType",
            "format": ""
        },
        {
            "name": "userPoolId",
            "baseName": "userPoolId",
            "type": "string",
            "format": ""
        },
        {
            "name": "cognitoClientId",
            "baseName": "cognitoClientId",
            "type": "string",
            "format": ""
        },
        {
            "name": "awsSubscriptionId",
            "baseName": "awsSubscriptionId",
            "type": "string",
            "format": ""
        },
        {
            "name": "azureSubscriptionId",
            "baseName": "azureSubscriptionId",
            "type": "string",
            "format": ""
        },
        {
            "name": "gcpSubscriptionId",
            "baseName": "gcpSubscriptionId",
            "type": "string",
            "format": ""
        },
        {
            "name": "users",
            "baseName": "users",
            "type": "Array<User>",
            "format": ""
        },
        {
            "name": "supportedProviders",
            "baseName": "supportedProviders",
            "type": "SupportedProviders",
            "format": ""
        },
        {
            "name": "byovEnabled",
            "baseName": "byovEnabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "msaAcceptance",
            "baseName": "msaAcceptance",
            "type": "MsaAcceptanceResponse",
            "format": ""
        },
        {
            "name": "labels",
            "baseName": "labels",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "companyContacts",
            "baseName": "companyContacts",
            "type": "Array<CompanyContact>",
            "format": ""
        },
        {
            "name": "createdAt",
            "baseName": "createdAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "eonOrganizationId",
            "baseName": "eonOrganizationId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return EonAccount.attributeTypeMap;
    }
    constructor() {
    }
}
